import React, { useState, useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import ImageUpload from "./ImageUpload";
import ProjectDetails from "./ProjectDetails";
import OpenPositions from "./OpenPositions";
import ProjectActions from "./ProjectActions";
import TeamMembers from "./TeamMembers";
import Modal from "../Hesabim/Modal";
import PositionCard from "./PositionCard";
import {
  fetchProjectDetails,
  fetchProjectImage,
  fetchProjectPositions,
  updateProject,
  addPosition,
} from "../../redux/slices/projectEditSlice";
import EditPageLoader from "../../components/loader/EditPageLoader";

const ProjectEditPage = () => {
  const location = useLocation();
  const { projectId: urlProjectId } = useParams();
  const dispatch = useDispatch();
  const { project, image, positions, loading, error } = useSelector(
    (state) => state.projectEdit
  );
  const [isOpen, setIsOpen] = useState(false);
  const [modalType, setModalType] = useState("");
  const [newPositions, setNewPositions] = useState([]);
  // Pozisyon silme fonksiyonu
  const handleRemovePosition = (indexToRemove) => {
    setNewPositions((prevPositions) =>
      prevPositions.filter((_, index) => index !== indexToRemove)
    );
  };

  // initialData'yı her zaman yeni bir obje olarak oluştur
  const initialData = project
    ? {
        name: project.title || "",
        completion: project.completed_percentage,
        description: project.definition || "",
      }
    : null;

  // formData state'ini initialData ile başlat
  const [formData, setFormData] = useState(initialData);

  // URL'den veya location.state'ten projectId'yi al
  const projectId = location.state?.projectId || urlProjectId;

  // Sayfa yüklendiğinde proje bilgilerini çek
  useEffect(() => {
    if (projectId) {
      dispatch(fetchProjectDetails(projectId));
      dispatch(fetchProjectImage(projectId));
      dispatch(fetchProjectPositions(projectId));
    }
  }, [dispatch, projectId]);

  // project değiştiğinde formData'yı güncelle
  useEffect(() => {
    if (project) {
      setFormData({
        name: project.title || "",
        completion: project.completed_percentage,
        description: project.definition || "",
      });
    }
  }, [project]);

  const handlePositionAdd = (positionData) => {
    console.log("Modal positionData:", positionData);
    const updatedPositionData = {
      positionName:
        typeof positionData.positionName === "object"
          ? positionData.positionName.name
          : positionData.positionName || "",
      expectations: Array.isArray(positionData.expectations)
        ? positionData.expectations.map((exp) =>
            typeof exp === "object" ? exp.name : exp
          )
        : [],
      type: positionData.positionType, // positionType öncelikli
    };
    setNewPositions((prevPositions) => [...prevPositions, updatedPositionData]);
  };

  const handleSave = async () => {
    try {
      await dispatch(
        updateProject({
          projectId,
          updateData: formData,
        })
      ).unwrap();

      if (newPositions.length > 0) {
        console.log("newPositions before dispatch:", newPositions);
        await dispatch(
          addPosition({
            positions: newPositions.map((pos) => ({
              title: pos.positionName,
              techs: pos.expectations.map((exp) => ({ name: exp })),
              type: pos.type,
            })),
            projectId,
          })
        ).unwrap();
      }

      // toast.success kaldırıldı, ProjectActions'da kalacak
      dispatch(fetchProjectDetails(projectId));
      dispatch(fetchProjectPositions(projectId));
      setNewPositions([]);
    } catch (error) {
      console.error("handleSave error:", error);
      throw error; // ProjectActions'da yakalanacak
    }
  };
  //console.log("newPositions:", newPositions);
  // Yükleme ve hata durumlarını yönet
  if (loading) return <EditPageLoader />;
  if (error) return <div>Hata: {error}</div>;
  if (!project) return <div>Proje bulunamadı.</div>;

  // console.log("ProjectEditPage formData:", formData); // Hata ayıklama için

  return (
    <div className="containerMain flex flex-col gap-6">
      <h1 className="text-2xl font-bold leading-[36px]">Projeyi Düzenle</h1>

      <div className="grid grid-cols-1 md:grid-cols-[248px_1fr] gap-6">
        <div className="left-area flex flex-col gap-8">
          <ImageUpload initialImage={image} relatedId={projectId} />
        </div>

        <div className="right-area flex flex-col gap-8 overflow-hidden max-w-screen">
          <ProjectDetails
            onFormChange={setFormData}
            initialData={initialData}
            key={project._id} // initialData'nın değiştiğinden emin olmak için
          />
          <OpenPositions
            positions={positions}
            setIsOpen={setIsOpen}
            setModalType={setModalType}
            projectId={projectId}
          />

          {/* Yeni eklenen pozisyonları göster */}
          {newPositions.length > 0 && (
            <div className="detay-container">
              <h2 className="text-dark font-medium text-xl">
                Yeni Eklenen Pozisyonlar
              </h2>
              <div className="pt-4">
                {newPositions.map((position, index) => (
                  <div key={`new-position-${index}`} className="mb-4">
                    <PositionCard
                      position={{
                        id: `new-position-${index}`,
                        title: position.type
                          ? `${position.type} ${position.positionName}`
                          : position.positionName,
                        techs: position.expectations.map((exp, index) => ({
                          id: `tech-${index}-${exp}`,
                          name: exp,
                        })),
                      }}
                      onRemove={() => handleRemovePosition(index)} // Çarpı için
                    />
                    {index !== newPositions.length - 1 && (
                      <hr className="border-gray-300 my-4" />
                    )}
                  </div>
                ))}
              </div>
            </div>
          )}
          <TeamMembers
            team={project.teamMembers}
            // projectId'yi gönderiyoruz projectId={projectId}
          />

          <ProjectActions
            formData={formData}
            onSave={handleSave}
            loading={loading}
          />
        </div>
      </div>
      {isOpen && (
        <Modal
          type={modalType}
          onClose={() => setIsOpen(false)}
          onPositionAdd={handlePositionAdd}
        />
      )}
    </div>
  );
};

export default ProjectEditPage;
